import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import moment from "moment";
import log from '../../../helpers/logger'
import { auth, getCurrentUser } from '../../../helpers/auth'
import { getTimeStamp, getUUIDV4 } from '../../../helpers/utils'
import {
  createFile_book_download_url_list,
  updateFile_book_download_url_list,
  deleteFile_book_download_url_list,
  getFile_book_download_url_list,
  getFile_book_download_url_listList } from '../../../services/File_book_download_url_listService'

function setErrorMsg(error) {
  return {
    errorMsg: error.message
  }
}

export default class File_book_download_url_listPageList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      errorMsg: null,
      currentUser: null,
      isLoading: true,
      dataList: []
    };

  }

  componentWillMount() {
    log.debug('componentWillMount')
  }
  async componentDidMount(){
    log.debug('componentDidMount')
    let user = await getCurrentUser();
    this.setState({currentUser: user})

    let dataList = await getFile_book_download_url_listList();
    /*
    log.debug(dataList.length)
    dataList.forEach(function(doc) {
        log.debug(doc.id, " => ", doc.data());
    });
    */

    log.debug('all data is loaded.')
    this.setState({dataList: dataList})
    this.setState({isLoading: false})
  }

  render () {

    let content;

    if (this.state.isLoading) {
      content = <div>Loading...</div>;
    } else {
      content =
      <div>
          <h4 className="page-header">
          <Link to='/file_book_download_url_list'>File_book_download_url_list</Link> ->
          List
        </h4>
          <table className="table">
              <thead>
                  <tr>
                      <th> file_book_download_url_list_id </th>
                    
                      <th>file_url</th> 
                      <th>filename</th> 
                      <th>issue_id</th> 
                      <th>date_created</th> 
                      <th> Actions </th>
                  </tr>
              </thead>
              <tbody>
                {
                  this.state.dataList.map((data, index) =>
                  <tr key={index}>
                    <td>{data.id}</td>
                    
                      <td>{data.data().file_url} </td> 
                      <td>{data.data().filename} </td> 
                      <td>{data.data().issue_id} </td> 
                      <td>{data.data().date_created} </td> 
                    {/* <td>{moment(data.data().date_created).fromNow()}</td> */}
                    <td>
                      <Link className="btn btn-small btn-primary" to={`/file_book_download_url_list/view/${data.id}`}>view</Link>
                    </td>
                  </tr>
                )
                }
              </tbody>
          </table>
          <p>
              <Link className="btn btn-success" to='/file_book_download_url_list/add'>Add New File_book_download_url_list</Link>
          </p>
      </div>
    }


    return (
      <div>
          {content}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/File_book_download_url_listPage/File_book_download_url_listPageList.js